import StoresRepository from './StoresRepository';

export * from './StoresRepository';

export default StoresRepository;
